interface IconTemperatureProps {
  size?: number | string;
  color?: string;
  className?: string;
}
/**
 *
 * IconTemperature
 */
const IconTemperature = ({ size = 48, color = '#F8C244', className }: IconTemperatureProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_93_9688)">
      <path
        d="M30.48 22.4999V10.8199C30.48 7.9199 28.54 5.2599 25.7 4.7199C21.88 3.9799 18.52 6.8999 18.52 10.5799V22.4999C18.52 24.3199 17.98 26.1199 16.84 27.5399C15.14 29.6399 14.3 32.4599 14.88 35.4799C15.6 39.2999 18.62 42.4199 22.42 43.1999C28.76 44.5199 34.34 39.7199 34.34 33.5999C34.34 31.3799 33.58 29.3399 32.34 27.6999C31.18 26.1999 30.52 24.3799 30.52 22.4999H30.48ZM24.5 8.5799C25.6 8.5799 26.48 9.4599 26.48 10.5599V19.5799H22.52V10.5599C22.52 9.4599 23.4 8.5799 24.5 8.5799Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_93_9688">
        <rect width="48" height="48" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default IconTemperature;
